import React from "react";
import Modal from "react-responsive-modal";
import LoadMask from "../../../../../../../../Utils/LoadMask/LoadMask";
import Paginacion from "../../../../../../../../Utils/Components/Paginacion/Paginacion";
import { PalletsRechazadosTable } from "./PalletsRechazadosTable";
import { useNumeroPallet } from "../../hooks/useNumeroPallet";

export const ModalNumeroPallet = (props) => {
    const { opened, onClose, palletRechazado, setPalletRechazado } = props;

    const numeroPallet = useNumeroPallet({
        opened,
        onClose,
        palletRechazado,
        setPalletRechazado,
    });

    return (
        <Modal
            open={opened}
            onClose={onClose}
            closeOnOverlayClick={false}
            focusTrapped={false}
        >
            <LoadMask loading={numeroPallet.cargando} blur>
                <h4 className="text-center mb-2">Número del pallet a formar</h4>

                <p className="text-center mb-3">
                    Puede reutilizar el número de un pallet que bodega haya
                    rechazado, o dejar que se genere un número nuevo.
                </p>

                <div
                    className="formulario-field mb-0 mt-0"
                    style={{ maxWidth: "220px" }}
                >
                    <label className="text-nowrap">Buscar</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Número, producto o EVS"
                        value={numeroPallet.search}
                        onChange={(e) =>
                            numeroPallet.handleSearch(e.target.value)
                        }
                    />
                </div>

                <PalletsRechazadosTable numeroPallet={numeroPallet} />

                <Paginacion
                    cantidadResultados={numeroPallet.cantidadResultados}
                    paginaSeleccionada={numeroPallet.paginaSeleccionada}
                    setPaginaSeleccionada={numeroPallet.setPaginaSeleccionada}
                />

                <div className="d-flex flex-wrap justify-content-center mt-4 mb-2 gap-1rem">
                    <button className="btn btn-outline-dark" onClick={onClose}>
                        Regresar
                    </button>

                    <button
                        className="btn btn-primary"
                        onClick={numeroPallet.handleNumeroNuevo}
                    >
                        Usar número nuevo
                    </button>
                </div>
            </LoadMask>
        </Modal>
    );
};
